<template>
  <v-container>
    <v-card v-bind:style="styleObject">
      <div class="card-header" style="background-color: #004a7b !important;">
        <img width="40%" :src="require(`@/assets/img/logoafp.jpg`)" />
        <br /><span class="font-weight-regular"
          >List Registrasi Kongres AFP Jatim 2021</span
        >
      </div>

      <v-data-table
          :headers="headers"
          :items="listRegister"
          class="elevation-1"
          color="green lighten-1"
      >
        <template v-slot:[`item.no`]="{ item }">
          {{(listRegister.indexOf(item)+1) + '.'}}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find, uniqBy } from "lodash";
import moment from 'moment';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
const db = firebase.firestore();
export default {
  name: "ListRegisterCongress",
  components: {
  },
  data() {
    return {
      styleObject: {
        width: "fit-content",
        margin: "1rem auto",
        borderRadius: "8px",
      },
      menu: false,
      inputDate: null,
      listRegister: [],
      headers: [
          {
            text: 'No.',
            align: 'start',
            value: 'no'
          },
          {text: 'Name',value: 'name'},
          {text: 'Organization',value: 'organization'},
          {
            text: 'Telepon',
            align: 'start',
            value: 'telp'
          },
          {text: 'Email',value: 'email'},
          {text: 'Waktu Registrasi',value: 'date'},
          {text: 'Tipe Kehadiran',value: 'tipe_kehadiran'}
      ],
    };
  },
  computed: {
      ...mapGetters({
      }),
      ...mapState({
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async initialize(){
      let list = []
      await db.collection("AFP_CONGRESS_REGISTRASI").get().then(function(querySnapshot) {
        querySnapshot.forEach(async function(doc) {
          let temp = {
            ...doc.data(),
            tipe_kehadiran:'-' 
          }
          await db.collection("AFP_CONGRESS_MANDAT").where("registerId", "==", doc.data().id)
          .get()
          .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                  console.log(doc.id, " => ", doc.data());
                  temp.tipe_kehadiran=doc.data().offline
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });

          list.push(temp)
        });
      });
      this.listRegister = list
    },
  }
};
</script>
<style scoped>
.card-header {
  text-align: center;
  padding: 1rem;
}
.card-header span {
  margin: 0;
  color: #fff;
}
.btn {
  background-color: #004d40 !important;
  color: #fff;
  padding: 0;
  text-transform: capitalize !important;
  /* font-size:1.3rem */
}
</style>
